<template>
  <div id="app">
    <md-snackbar :md-position="vertical + ' ' + horizontal" ref="snackbar" :md-duration="duration">
      <span>{{message}}</span>
    </md-snackbar>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  data: () => ({
    vertical: 'top',
    horizontal: 'center',
    duration: 5000,
    message: ''
  }),
  mounted () {
    var snackbar = this.$refs.snackbar
    var data = this.$data
    this.$root.$on('showMessages', function (msg) {
      console.log(msg)
      this.$set(data, 'message', msg)
      snackbar.open()
    })
  }
}

</script>

<style lang='sass'>
@import "sass/variables.scss"

body { margin: 0;}

#app { font-family: $appFont
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #2c3e50}

main { text-align: center
  margin-top: 40px}

header { margin: 0
  height: 56px
  padding: 0 16px 0 24px
  background-color: #4fc08d
  color: #ffffff;}

header span { display: block
  position: relative;
  font-size: 20px;
  line-height: 1;
  letter-spacing: .02em;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 16px;}

.md-sidenav.md-right .md-sidenav-content  { width: 90% !important;}

.md-theme-default.md-sidenav .md-sidenav-content { position: fixed;}

</style>



// WEBPACK FOOTER //
// App.vue?212eeba0